// extracted by mini-css-extract-plugin
export default {"message-avatars":"message-avatars__bpc8g","message-avatars__avatar":"message-avatars__avatar__KvWCV"};